import SVGIcon from './../SVGIcon';

export const iconSolidTriangle = props => (
  <SVGIcon width={576} height={512} {...props}>
    <path
      fill="#FFFFFF"
      d="M329.6 24c-18.4-32-64.7-32-83.2 0L6.5 440c-18.4 31.9 4.6 72 41.6 72H528c36.9 0 60-40 41.6-72l-240-416z"
    />
  </SVGIcon>
);
